function objectToQueryString(obj) {
  return Object.keys(obj).map(key => key + '=' + encodeURIComponent(obj[key])).join('&');
}

function ajaxRequest(type, url, data, queryParams) {
  return new Promise(function(resolve, reject) {
    var xhr = new XMLHttpRequest();

    if (queryParams) {
      var queryString = objectToQueryString(queryParams);
      url += '?' + queryString;
    }

    xhr.open(type, url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          reject(xhr.statusText);
        }
      }
    };
    xhr.onerror = function() {
      reject(xhr.statusText);
    };
    xhr.send(JSON.stringify(data));
  });
}

function getCart() {
  return ajaxRequest('GET', `${window.Shopify.routes.root}cart.js`);
}

function updateCart(selectedLocation) {
  let attributes = {
    selected_location: selectedLocation
  };
  return ajaxRequest('POST', `${window.Shopify.routes.root}cart/update.js`, { attributes });
}

function cleanCart() {
  return ajaxRequest('POST', `${window.Shopify.routes.root}cart/clear.js`);
}
